module.exports = __webpack_public_path__ + "img/2d2e7fb.jpg";